/**
 * Format currency for vendor estimates
 * - Uses vendor currency if set
 * - Defaults to ₹ (INR) for vendors if currency is not set
 * - Always uses $ (USD) for client estimates
 */
export const formatVendorCurrency = (
  amount: number,
  vendorCurrency?: string | null
): string => {
  // Default to INR (₹) for vendors if currency is not set
  const currencyCode = vendorCurrency || 'INR';
  const locale = currencyCode === 'INR' ? 'en-IN' : 'en-US';
  
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currencyCode,
  }).format(amount || 0);
};

/**
 * Format currency for client estimates
 * - Always uses $ (USD) for client estimates
 */
export const formatClientCurrency = (amount: number): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount || 0);
};

/**
 * Get currency symbol for vendor estimates
 * - Returns vendor currency symbol if set
 * - Defaults to ₹ for vendors if currency is not set
 */
export const getVendorCurrencySymbol = (vendorCurrency?: string | null): string => {
  const currencyCode = vendorCurrency || 'INR';
  
  // Map currency codes to symbols
  const currencySymbols: Record<string, string> = {
    'INR': '₹',
    'USD': '$',
    'EUR': '€',
    'GBP': '£',
  };
  
  return currencySymbols[currencyCode] || currencyCode;
};












